import styled from "styled-components";

export const SignInContainer = styled.div`
  margin: 0 60px;
  display: flex;
  justify-content: space-evenly;
`;

export const SignInText = styled.div`
  width: 40%;
`;
export const SignInTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin: 30px 0;
`;
export const SignInDescription = styled.p`
  font-size: 14px;
`;

export const SignInForm = styled.form`
  width: 30%;
`;
